import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Eye } from "lucide-react";
import { adminApi } from "../../lib/api";
import PageBlocks from "../../components/PageBlocks";
import Seo from "../../components/Seo";

export default function PagePreview() {
  const { id } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    adminApi.pages.get(id).then(setPage).catch(() => setError(true)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading preview…</div>;
  if (error || !page) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <h1 className="font-display font-extrabold text-3xl text-navy mb-3">Preview unavailable</h1>
        <Link to="/admin" className="inline-flex items-center gap-2 text-orange font-bold"><ArrowLeft size={16} /> Back to admin</Link>
      </div>
    );
  }

  const hasHero = (page.blocks || []).some((b) => b.type === "hero");

  return (
    <div data-testid="page-preview">
      <Seo title={`Preview: ${page.title}`} noindex />
      <div className="bg-amber-500 text-white text-center text-sm font-semibold py-2 px-4 flex items-center justify-center gap-2 sticky top-0 z-50">
        <Eye size={15} /> Preview mode {page.published ? "" : "— this page is not published yet"}
      </div>
      {!hasHero && (
        <section className="numbers-pattern text-white">
          <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-20">
            <h1 className="font-display font-extrabold text-4xl md:text-6xl uppercase leading-[0.95]">{page.title}</h1>
          </div>
        </section>
      )}
      <PageBlocks blocks={page.blocks || []} pageTitle={page.title} />
    </div>
  );
}
